import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ariaLabel", "onOpenChange"];
import { useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Popover } from 'trellis-components/components/Popover';
import { unsafeReactNode } from 'trellis-components/utils/unsafeReactNode';
import { useUiVariant } from './UiVariantProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const _temp = {
  maxWidth: "x13i5qev",
  "$$css": true
};
const styles = {
  content: maxInlineSize => [_temp, {
    "--x-maxInlineSize": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(maxInlineSize)
  }]
};
const TrellisCdpInfotip = ({
  ariaLabel,
  children,
  disabled,
  headingText,
  maxInlineSize = '280px',
  onOpenChange,
  open,
  placement = 'top',
  referenceTabIndex = 0,
  title
}) => {
  const [anchor, setAnchor] = useState(null);
  // Disabling keeps the same tree, so toggling it doesn't remount children
  // (PropertyFormattedTooltip wraps a focused input).
  const isDisabled = disabled || title == null;
  const popoverProps = {
    title: headingText != null ? unsafeReactNode(headingText) : undefined,
    ariaLabel: headingText == null && ariaLabel ? {
      root: ariaLabel
    } : undefined,
    side: placement,
    initialFocus: false,
    onOpenChange: next => {
      if (!isDisabled) {
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(next);
      }
    },
    children: /*#__PURE__*/_jsx("div", Object.assign({}, stylex.props(styles.content(String(maxInlineSize))), {
      children: title
    }))
  };

  // A controlled infotip stays up next to its target (an input, for
  // example), so it anchors to it instead of turning it into a trigger.
  if (open != null) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", Object.assign({
        ref: setAnchor
      }, {
        className: "x1rg5ohu"
      }, {
        children: children
      })), anchor != null && !isDisabled && /*#__PURE__*/_jsx(Popover, Object.assign({}, popoverProps, {
        open: open,
        anchor: anchor
      }))]
    });
  }
  return /*#__PURE__*/_jsx(Popover, Object.assign({}, popoverProps, isDisabled && {
    open: false
  }, {
    openOnHover: true,
    nativeTriggerButton: false,
    trigger: /*#__PURE__*/_jsx("span", Object.assign({
      tabIndex: isDisabled ? -1 : referenceTabIndex
    }, {
      className: "x1rg5ohu"
    }, {
      children: children
    }))
  }));
};
export const CdpInfotip = props => {
  const variant = useUiVariant();
  if (variant === 'trellis') {
    return /*#__PURE__*/_jsx(TrellisCdpInfotip, Object.assign({}, props));
  }
  const {
      onOpenChange
    } = props,
    tooltipProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({}, tooltipProps, {
    onOpenChange: onOpenChange && (event => onOpenChange(event.target.value))
  }));
};